import { deviceType, controlType, isUserAdmin, isUserSupport, siteFleetType } from "constant";

// accepts both the API wrapper { Car: {...} } and the inner Car object itself
const unwrapCar = (car) =>
    car && typeof car === "object" && car.Car && typeof car.Car === "object" ? car.Car : car;

export const isFtPlusNoScreenCar = (car) => {
    const c = unwrapCar(car);
    const ctl = c?.CarControlType;
    return (
        c?.DevType === deviceType.FT2 &&
        (ctl === null ||
            ctl === "" ||
            ctl === undefined ||
            ctl === controlType.None ||
            ctl === controlType.LIN ||
            ctl === controlType.Fusion)
    );
};

export const shouldShowSendMessageButton = (car, getUserRole) => {
    return (
        isUserAdmin(getUserRole && getUserRole?.Role) ||
        isUserSupport(getUserRole && getUserRole?.Role) ||
        !isFtPlusNoScreenCar(car)
    );
};

// 100% FT+ fleet only - a mixed fleet still shows the toolbar button
export const isFt2OnlyFleet = (fleetType) => {
    return (
        fleetType === siteFleetType.ft2Electric ||
        fleetType === siteFleetType.ft2Gas ||
        fleetType === siteFleetType.ft2Mixed
    );
};
